export default [
  {
    path: '/Usercenter',
    component: () => import('@/views/HomePage'),
    children: [
      {
        path: '',
        component: () => import('@/views/HomePage/Usercenter')
      }
    ]
  }
]
